import React from 'react';
import Sidebar from '../components/Sidebar';
import AssistantWorkspace from '../components/assistant/AssistantWorkspace';

function AsistenteAdmin() {
  return (
    <div className="flex min-h-screen bg-[#f4f7f8] dark:bg-background-dark">
      <Sidebar />

      <main className="flex-1 overflow-y-auto">
        <div className="p-6 md:p-8">
          <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-cyan-700 dark:text-cyan-300">
                Herramienta interna
              </p>
              <h1 className="mt-2 text-3xl font-black tracking-[-0.03em] text-slate-900 dark:text-white">
                Asistente administrativo
              </h1>
              <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-500 dark:text-slate-400">
                Abrí chats nuevos para cortar contexto, consultá deuda, lecturas, pagos o
                tarifario, y usá atajos directos a las pantallas del sistema.
              </p>
            </div>

            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-cyan-50 px-4 py-2 text-sm font-semibold text-cyan-900 dark:border-cyan-500/30 dark:bg-cyan-500/10 dark:text-cyan-100">
              <span className="material-symbols-outlined">support_agent</span>
              RAG documental + datos vivos
            </div>
          </header>

          <AssistantWorkspace />
        </div>
      </main>
    </div>
  );
}

export default AsistenteAdmin;
